import { useContext, useState } from 'react'
import { filterType, ItemQuery } from '@components/Items/types'
import { buildQueries } from '@components/Items/utils/functions'
import useDidMountEffect from '@utilities/hooks/useDidMountEffect'
import { AuthContext } from '../../../../contexts/AuthContext'

const useFilters = (
  initialFilterData: filterType,
  query: ItemQuery,
  staticQueries: ItemQuery = {}
) => {
  const { instance } = useContext<any>(AuthContext)
  const [filterData, setFilterData] = useState<filterType>(initialFilterData)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const fetchNewFilters = async () => {
    const { data } = await instance.get(
      `/search/searchItemFilters${buildQueries({
        ...query,
        ...staticQueries,
      } as any)}`
    )
    setFilterData(data)
  }

  useDidMountEffect(() => {
    fetchNewFilters()
  }, [query])

  return {
    filterData,
    isLoading,
  }
}

export default useFilters
